// extracted by mini-css-extract-plugin
export default {"empty":"TableWrapper_empty__0TY8u","skeleton":"TableWrapper_skeleton__FzGNA"};